import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Programme, CreateProgrammeRequest, UpdateProgrammeRequest } from '@/shared/types/admin'

export const programmesApi = {
  getAll: () =>
    api.get<ApiResponse<Programme[]>>('/api/programmes').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Programme>>(`/api/programmes/${id}`).then((r) => r.data.data),

  getActifs: () =>
    api.get<ApiResponse<Programme[]>>('/api/programmes/actifs').then((r) => r.data.data),

  create: (data: CreateProgrammeRequest) =>
    api.post<ApiResponse<Programme>>('/api/programmes', data).then((r) => r.data.data),

  update: (id: number, data: UpdateProgrammeRequest) =>
    api.put<ApiResponse<Programme>>(`/api/programmes/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/programmes/${id}`),
}
